import $ from 'jquery';

$(document).ready(() => {
  $('body').attr('ontouchstart', '');
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/base/base.js